import { createTheme, lighten } from "@mui/material/styles";

import {
  dangerColor,
  onyxGreenColor,
  successColor
} from "assets/jss/default/theme";

const theme = createTheme({
  palette: {
    primary: {
      light: lighten("#009F33", 0.2),
      main: "#009F33",
      contrastText: "#FFFFFF"
    },
    secondary: {
      light: lighten("#19173F", 0.2),
      main: "#19173F",
      contrastText: "#FFFFFF"
    },
    action: {
      hover: "rgba(76, 175, 80, 0.3)",
      selected: "rgba(76, 175, 80, 0.3)"
    },
    background: {
      default: "#E5E5E5",
      paper: "#FFFFFF",
      main: "#009F33"
    },
    chipDefault: {
      light: lighten("#e0e0e0", 0.2),
      main: "#e0e0e0",
      contrastText: "#000"
    }
  },
  components: {
    MuiStack: {
      defaultProps: {
        useFlexGap: true
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          "& .MuiAccordionSummary-expandIcon": {
            padding: "12px"
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: "2px",
          "& .MuiSvgIcon-root:hover": {
            color: onyxGreenColor,
            backgroundColor: successColor[6],
            borderRadius: 50
          },
          "& .MuiIconButton:hover": {
            color: onyxGreenColor,
            backgroundColor: successColor[6]
          },
          MuiButtonBase: {
            root: {
              backgroundColor: successColor[6]
            }
          }
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          "& .MuiButtonBase-root": {
            backgroundColor: "rgba(0,0,0,0)",
            padding: "5px",
            "& .MuiTypography-root:hover": {
              backgroundColor: successColor[6]
            }
          }
        }
      }
    },
    MuiChip: {
      defaultProps: {
        color: "chipDefault"
      }
    },
    MuiDropzoneSnackbar: {
      styleOverrides: {
        errorAlert: {
          backgroundColor: dangerColor[0],
          color: "#000"
        },
        successAlert: {
          backgroundColor: onyxGreenColor,
          color: "#000"
        }
      }
    },
    MuiDropzoneArea: {
      styleOverrides: {
        text: {
          margin: 10,
          marginBottom: 5,
          fontSize: "1rem"
        },
        root: {
          minHeight: 150,
          height: "100%",

          "&.Mui-active": {
            borderColor: successColor[0],
            backgroundImage:
              "repeating-linear-gradient(-45deg, #388e3c, #388e3c 25px, #5cb860 25px, #5cb860 50px)"
          }
        },
        invalid: {
          borderColor: dangerColor[0]
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          color: "#fff",
          backgroundColor: onyxGreenColor
        },
        indicator: {
          backgroundColor: "#000"
        }
      }
    },
    // Override the colour when a row is selected, by default it uses the secondary colour
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: "rgba(76, 175, 80, 0.5)"
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        // Table header overrides
        stickyHeader: {
          backgroundColor: "#FFFFFF"
        },
        head: {
          fontWeight: "bold",
          textAlign: "left"
        },
        footer: {
          color: "#000000",
          fontWeight: "bold",
          fontSize: "14px"
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: "16px"
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "16px",
          // Workaround for css specificity issue when using dialog title and content: https://github.com/mui/material-ui/issues/26795
          ".MuiDialogTitle-root + &": {
            paddingTop: "16px"
          }
        }
      }
    }
  }
});

export default theme;
